import React, { PureComponent } from 'react';
import { LargeCardCarousel, SmallCardCarousel, ExpandedCardCarousel, NarrowCardStack,
    ProductFocusedCardSet, ProductFocusedCardStack, ProductFocusedCardCarousel,
    ContentFocusedCardSet, ContentFocusedCardStack, ContentFocusedCardCarousel } from 'appSrc/components/List-Article/Carousels';
import { ProductCarousel } from 'appSrc/components/Product';
import { ReviewCardCarousel } from 'appSrc/components/Review';
import UserCarousel from 'appSrc/components/User/UserCarousel';
import PropTypes from 'prop-types';

class DLCarousel extends PureComponent {
    render() {
        const { carousel } = this.props;

        if( carousel.ui_type === 'large_card_carousel' ) {
            return ( <LargeCardCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'small_card_carousel' ) {
            return ( <SmallCardCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'expanded_card_carousel' ) {
            return ( <ExpandedCardCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'narrow_card_stack' ) {
            return ( <NarrowCardStack { ...this.props } /> );
        }
        if( carousel.ui_type === 'product-focused_card_set' ) {
            return ( <ProductFocusedCardSet { ...this.props } /> );
        }
        if( carousel.ui_type === 'product-focused_card_stack' ) {
            return ( <ProductFocusedCardStack { ...this.props } /> );
        }
        if( carousel.ui_type === 'product-focused_card_carousel' ) {
            return ( <ProductFocusedCardCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'content-focused_card_set' ) {
            return ( <ContentFocusedCardSet { ...this.props } /> );
        }
        if( carousel.ui_type === 'content-focused_card_stack' ) {
            return ( <ContentFocusedCardStack { ...this.props } /> );
        }
        if( carousel.ui_type === 'content-focused_card_carousel' ) {
            return ( <ContentFocusedCardCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'product_card_carousel' ) {
            return ( <ProductCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'product_review_carousel' ) {
            return ( <ReviewCardCarousel { ...this.props } /> );
        }
        if( carousel.ui_type === 'user_carousel' ) {
            return ( <UserCarousel { ...this.props } /> );
        }
        return null;
    }
}
DLCarousel.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
DLCarousel.defaultProps = {
    className: '',
    carousel: {},
};

export default DLCarousel;
